/**
 * useShellShortcuts - the shell's keyboard, as `useKeyboardShortcuts` takes it.
 *
 * Tab walks the RAIL (v8.320.0); E ends the turn only while the tracker
 * runs; Space fires the CHAMBER, not always the plain attack (v8.236.0).
 * Dismissing a reaction deletes its document for everyone, so Escape keeps
 * the reach it had when a prompt could only be for the tab you were on: it
 * clears only a LOUD one. Extracted from DeathWatchSimulator.
 */
import useKeyboardShortcuts from './useKeyboardShortcuts.js';

/**
 * @param {object} args - everything `useKeyboardShortcuts` reads, with
 *   `cycleRail`, `turnTracker`, `handleAttackOrChambered`, `reactions` and
 *   `clearPendingDefenceFirestore` under the shell's own names.
 */
export default function useShellShortcuts(args) {
  const { turnTracker, reactions } = args;
  useKeyboardShortcuts({
    cycleTab: args.cycleRail,
    endTurn: turnTracker.trackerState.active ? turnTracker.endTurn : undefined,
    handleAttack: args.handleAttackOrChambered,
    doResetTarget: args.doResetTarget,
    handleReload: args.handleReload,
    handleNewTab: args.handleNewTab,
    handleDuplicateTab: args.handleDuplicateTab,
    toggleActionDrum: args.toggleActionDrum,
    doClearNarrative: args.doClearNarrative,
    setShowHotkeys: args.setShowHotkeys,
    setEditingSlot: args.setEditingSlot,
    setTabCtx: args.setTabCtx,
    overlayOpen: args.overlayOpen,
    setPendingAttack: args.setPendingAttack,
    setSlotClipboard: args.setSlotClipboard,
    setSelectedSlot: args.setSelectedSlot,
    doUndo: args.doUndo,
    activeTab: args.activeTab,
    currentSlots: args.currentSlots,
    dialog: args.dialog,
    handleDialogClose: args.handleDialogClose,
    clearPendingDefence: args.clearPendingDefenceFirestore,
    focusedReactionId: args.focusedReactionId,
    escapeCanClear: reactions.focused?.volume === 'loud',
    sessionId: args.sessionId,
  });
}
